import React, { Component, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import CommonAlert from "../common/Commonalert";
import Sidebar from "../common/sidebar";
import ShowAlert from "../common/Showalert";
import { canAction } from "../common/permissionhelper";
import { useTranslation } from "react-i18next";
const MODULE = "manage_settings";

const Editallergen = () => {
  const { t } = useTranslation();
  const canEdit = canAction(MODULE, "edit");
  const isReadOnly = !canEdit; // if true, disable inputs and hide submit
  const [allergens_txt, setAllergens_Txt] = useState([]);
  const [preallergens_txt, setPreAllergens_Txt] = useState([]);
  const [errormsg, setErrormsg] = useState({});
  const [errmessage, setErrMessage] = useState({});
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState([]);
  const [alerterrorPopup, setAlertErrorPopup] = useState(false);
  const [alerterrMessage, setAlerterrMessage] = useState([]);
  const [allergenslist, setAllergenslist] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const params = useParams();

  const routeChange = () => {
    window.location.href = "/allergens";
  };
  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = "/";
  }
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_settings")
  ) {
    window.location.href = "/unauthorized";
  }

  useEffect(() => {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    setIsLoading(true);
    let URL = BaseUrl + `admin/allergen/${params.id}`;
    http
      .get(URL)
      .then((response) => {
        let responseData = response.data.data;
        setAllergens_Txt(responseData[0].allergenTitle);
        setPreAllergens_Txt(responseData[0].allergenTitle);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
    let URL1 = BaseUrl + "admin/allergenlist";
    http
      .get(URL1)
      .then((response) => {
        let responseData = response.data.data;
        setAllergenslist(responseData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const btnsubmit = (e) => {
    e.preventDefault();
    if (isReadOnly) return;
    const isValid = formvalidation();
    if (isValid) {
      let allergenstxt = allergens_txt.trim().toUpperCase();
      if (preallergens_txt != allergenstxt) {
        var isFound = allergenslist.some((element) => {
          if (element.allergenTitle === allergenstxt) {
            return true;
          }
          return false;
        });
      } else {
        var isFound = false;
      }
      if (isFound) {
        setAlertErrorPopup(true);
        setAlerterrMessage(t("allergen_already_exists_txt"));
      } else {
        var loginDetails = {};
        if (sessionStorage.getItem("authData")) {
          loginDetails = JSON.parse(sessionStorage.getItem("authData"));
        }
        const formData = new FormData();
        formData.append("allergenid", params.id);
        formData.append("allergenTitle", allergenstxt);
        let URL = BaseUrl + "admin/allergen/";
        http
          .put(URL, formData)
          .then(async (response) => {
            let responseData = response.data.data;
            if (response.data.success === true) {
              setAlertPopup(true);
              setAlertMessage(t("allergen_updated_successfully_txt"));
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

  const formvalidation = () => {
    const errmessage = {};
    const errmsg = {};
    let isValid = true;
    if (allergens_txt == "") {
      errmessage.allergenstxterr = t("field_required_txt");
      errmsg.allgtxt = true;
      isValid = false;
    }
    if (isValid) {
      errmessage.allergenstxterr = "";
      errmsg.allgtxt = false;
      setErrMessage(errmessage);
      return isValid;
    } else {
      setErrMessage(errmessage);
      setErrormsg(errmsg);
      return isValid;
    }
  };

  const handleOnChange = (e) => {
    const re = /^[a-zA-Z][a-zA-Z ]*$/;
    if (e.target.name === "allergens_txt") {
      if (e.target.value === "" || re.test(e.target.value)) {
        setAllergens_Txt(e.target.value);
      }
      if (errmessage.allergenstxterr != "") {
        errormsg.allgtxt = false;
      }
      setErrormsg(errormsg);
    }
  };

  return (
    <section className="dashboard-block">
      {alerterrorPopup && (
        <ShowAlert title={t("alert_txt")} message={alerterrMessage} />
      )}
      {alertPopup && (
        <CommonAlert title={t("alert_txt")} message={alertMessage} />
      )}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container account-details">
            <h1 className="checkout-title">
              {canEdit ? t("edit_allergen_txt") : t("view_allergen_txt")}
            </h1>
            <div className="right-table-outer-wrap">
              {isLoading ? (
                <div className="loading-buffer"></div>
              ) : (
              <div className="form-field freeproduct-fieldset allergens-fieldset form-container-xs">
                <form className="client-detail-form">
                  <div className="input-field col-1">
                    <label htmlFor="name">{t("allergen_txt")}</label>
                    <input
                      type="text"
                      name="allergens_txt"
                      value={allergens_txt}
                      onChange={handleOnChange}
                      readOnly={isReadOnly}
                    />
                    {errormsg.allgtxt && (
                      <div className="error-msg">
                        {errmessage.allergenstxterr}
                      </div>
                    )}
                  </div>
                  <div className="btnfield">
                    {!isReadOnly && (
                      <button
                        title={t("update_txt")}
                        type="submit"
                        name="btnsubmit"
                        onClick={btnsubmit}
                      >
                        {t("update_txt")}
                      </button>
                    )}
                    &nbsp;&nbsp;&nbsp;
                    <button title={t("cancel_txt")} type="button" onClick={routeChange}>
                      {t("cancel_txt")}
                    </button>
                  </div>
                </form>
              </div>
              )}
            </div>
          </div>
          <Footer />
        </section>
      </div>
    </section>
  );
};
export default Editallergen;
